import { Component, Input } from '@angular/core';
import { ProfileService } from '../providers';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
  standalone: false,
})
export class OverlayComponent {
  @Input()
  public imgClass: string;
  constructor(public profileService: ProfileService) {}

  getLabelTranslation = (value: string, replacements?: Array<string>) => {
    return this.profileService.getLabelTranslation(value, replacements);
  };
}
